import { useMemo } from 'react'
import { SaturatedItem, stencil } from 'react-common'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { removeRootPath } from '@/features/layout/utils/removeRootPath'
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs'

const { BreadcrumbsPlugin, BreadcrumbItemComponent } = stencil

export const BreadcrumbsPluginContainer = () => {
  const { saturatedBreadcrumbs } = useBreadcrumbs()
  const { t } = useTranslation()

  const breadcrumbsItem = (item: SaturatedItem) => {
    return item.url ? <Link to={removeRootPath(item.url)}>{item.name}</Link> : <span>{item.name}</span>
  }

  const breadcrumbsItems = useMemo(() => {
    if (!saturatedBreadcrumbs?.size) {
      return null
    }

    const breadcrumbs: JSX.Element[] = []

    for (const [, breadcrumb] of saturatedBreadcrumbs) {
      breadcrumbs.push(
        <BreadcrumbItemComponent key={`breadcrumbItem-${breadcrumb.slug}`}>
          {breadcrumbsItem(breadcrumb)}
        </BreadcrumbItemComponent>,
      )
    }

    return breadcrumbs
  }, [saturatedBreadcrumbs])

  return <BreadcrumbsPlugin title={t('breadcrumbs.title')}>{breadcrumbsItems}</BreadcrumbsPlugin>
}
